import { connect } from 'react-redux';
import Global from '../../../store/global-selectors';

import OtherShippingOptionsForm from './other-shipping-options-form';

const mapStateToProps = (state) => {
  const sellerDefaultCurrency = Global.selectSellerDefaultCurrency(state);
  return {
    sellerDefaultCurrency,
  };
};

export default connect(mapStateToProps)(OtherShippingOptionsForm);
